<div [ngStyle]="{overflow: isFromPTP ? 'hidden' : ''}" id="outer" class="well container">
    @if (loading) {
        <div class="loading"></div>
    }
    <div class="col-md-12">
        <div class="well-notify"></div>
    </div>
    <div class="well-title">
        <div class="col-md-12">Upload {{ isFromPTP ? "Invoice" : "Document" }}</div>
    </div>
    <div class="col-md-12 well-content">
        @if (!hasChosenType) {
            <form class="form-horizontal" role="form">
                <div class="form-group">
                    <div class="col-md-12">Please select which document type you are uploading</div>
                </div>
                <div>
                    <div class="form-group">
                        <label class="col-md-2 control-label" for="documentTypes">Document Type</label>
                        <div class="col-md-10">
                            <nz-select
                                id="documentTypes"
                                nzShowSearch
                                nzPlaceHolder="Select a document type"
                                style="width: 100%"
                                [(ngModel)]="documentType"
                                [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="updateCommonFields()">
                                @for (opt of schema.Types; track opt) {
                                    <nz-option [nzValue]="opt.Id" [nzLabel]="opt.Name"></nz-option>
                                }
                            </nz-select>
                            @if (showTypeError) {
                                <div class="text-danger" style="font-size: 12px; margin-top: 4px">
                                    Please choose a document type.
                                </div>
                            }
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-offset-4 col-md-8">
                            <button class="btn btn-default pull-right" type="button" (click)="SelectDocumentType()">
                                Select Document Type
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        }
        @if (hasChosenType) {
            <form
                #uploadForm="ngForm"
                id="uploadForm"
                enctype="multipart/form-data"
                class="form-horizontal"
                role="form"
                [noValidate]="true"
                (ngSubmit)="Submit(uploadForm)">
                <div class="form-group">
                    <div class="col-md-12">Please enter metadata for the document</div>
                </div>
                <div>
                    <div class="form-group">
                        <div class="col-md-12">
                            <div class="form-group">
                                <div class="control-label col-md-2">Select File</div>
                                <div class="col-md-6">
                                    <input
                                        (change)="OnFileSelected($event)"
                                        name="uploadFile"
                                        id="uploadFile"
                                        type="file"
                                        required />
                                    @if (submitted && !hasChosenFile) {
                                        <div class="text-danger" style="font-size: 12px; margin-top: 4px">
                                            Please select a file to upload.
                                        </div>
                                    }
                                </div>
                            </div>
                            @for (item of commonFields; track item) {
                                <div class="form-group">
                                    <div class="control-label col-md-2">
                                        {{ item.Name }}
                                        @if (KeywordIsRequired(item.Id)) {
                                            <span style="color: red">*</span>
                                        }
                                    </div>
                                    <div class="col-md-6">
                                        @if (item.KeywordType !== 3) {
                                            <input
                                                [id]="item.KeywordType + '_' + item.Id"
                                                [name]="item.KeywordType + '_' + item.Id"
                                                [(ngModel)]="item.TextValue"
                                                type="text"
                                                class="form-control"
                                                style="width: 100%"
                                                [required]="KeywordIsRequired(item.Id)" />
                                        } @else {
                                            <nz-date-picker
                                                [nzId]="item.KeywordType + '_' + item.Id"
                                                name="{{ item.KeywordType + '_' + item.Id }}"
                                                style="width: 100%"
                                                [nzFormat]="item.DateFormat"
                                                nzPlaceHolder=" "
                                                [(ngModel)]="item.DateValue"
                                                [required]="KeywordIsRequired(item.Id)">
                                            </nz-date-picker>
                                            @if (
                                                uploadForm.controls[item.KeywordType + "_" + item.Id]?.invalid &&
                                                (uploadForm.controls[item.KeywordType + "_" + item.Id]?.touched ||
                                                    submitted)
                                            ) {
                                                <div class="text-danger" style="font-size: 12px; margin-top: 4px">
                                                    {{ item.Name }} is required.
                                                </div>
                                            }
                                        }
                                        @if (
                                            item.KeywordType !== 3 &&
                                            uploadForm.controls[item.KeywordType + "_" + item.Id]?.invalid &&
                                            (uploadForm.controls[item.KeywordType + "_" + item.Id]?.touched ||
                                                submitted)
                                        ) {
                                            <div class="text-danger" style="font-size: 12px; margin-top: 4px">
                                                {{ item.Name }} is required.
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                            @if (AnyKeywordIsRequired()) {
                                <div class="col-md-offset-2 col-md-10" style="font-size: 12px">
                                    <span style="font-size: 14px; color: red">*</span>signfies a required field
                                </div>
                            }
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-offset-2 col-md-4">
                            @if (!isFromPTP) {
                                <button class="btn btn-default" type="button" (click)="Cancel()">Cancel</button>
                            }
                            <button [disabled]="!hasChosenType" class="btn btn-default" type="submit">
                                Submit Document
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        }
    </div>
</div>
